var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "40 95 1470 1170",
    role: "img",
    "aria-label": "Anixify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "anx-dark",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 1400
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1400,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 1120,
    r: 65,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806,
    cy: 800,
    r: 65,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1357,
    cy: 1120,
    r: 65,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "anx-green",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 1400
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1400,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 255,
    r: 68,
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#anx-dark)",
    fill: "none",
    stroke: "#3A4145",
    strokeWidth: 78
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 1120,
    r: 103
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806,
    cy: 800,
    r: 100
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1357,
    cy: 1120,
    r: 103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 1120L806 800",
    strokeWidth: 92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 1090L735 340",
    strokeWidth: 104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 780C960 750 1045 752 1108 815S1200 950 1292 1078",
    strokeWidth: 100
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#anx-green)",
    fill: "none",
    stroke: "#AAD15E"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 255,
    r: 109,
    strokeWidth: 82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 255L1008 575",
    strokeWidth: 108
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9475a6cf3c412f84081de36e5db47b64.svg";
export { ForwardRef as ReactComponent };